(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["uandi-get-a-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('uandi-quote-block')) {
  customElements.define('uandi-quote-block', class extends HTMLElement {
    connectedCallback() {
      this._active = true;
      this._styles = new Map();
      this._apply = this._apply || (() => this.applyStyles());
      this._observer = new MutationObserver(this._apply);
      this._observer.observe(this, {childList: true, subtree: true});
      this._attempts = 0;
      this.applyStyles();

      // Shadow-root creation does not trigger the light-DOM observer.
      this._timer = setInterval(() => {
        this.applyStyles();
        if (++this._attempts >= 120) clearInterval(this._timer);
      }, 500);

      customElements.whenDefined('shopify-forms-embed').then(() => {
        if (this._active) this.applyStyles();
      });

      document.addEventListener('shopify:section:load', this._apply);
      document.addEventListener('shopify:block:select', this._apply);
    }

    applyStyles() {
      if (!this._active) return;

      const template = this.querySelector('template[data-uandi-form-css]');
      const source = template?.content.querySelector('style');
      if (!source) return;

      this.querySelectorAll('shopify-forms-embed').forEach(host => {
        if (host.closest('uandi-quote-block') !== this) return;

        const root = host.shadowRoot;
        if (!root) return;

        let entry = this._styles.get(host);
        if (!entry) {
          const style = source.cloneNode(true);
          root.appendChild(style);

          const observer = new MutationObserver(() => {
            if (this._active && style.parentNode !== root) {
              root.appendChild(style);
            }
          });

          observer.observe(root, {childList: true});
          entry = {style, observer};
          this._styles.set(host, entry);
        }
      });

      for (const [host, entry] of this._styles) {
        if (!this.contains(host)) {
          entry.observer.disconnect();
          entry.style.remove();
          this._styles.delete(host);
        }
      }
    }

    disconnectedCallback() {
      this._active = false;
      clearInterval(this._timer);
      this._observer?.disconnect();
      document.removeEventListener('shopify:section:load', this._apply);
      document.removeEventListener('shopify:block:select', this._apply);

      for (const entry of this._styles?.values() || []) {
        entry.observer.disconnect();
        entry.style.remove();
      }

      this._styles?.clear();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
